import { render, staticRenderFns } from "./warnEvent.vue?vue&type=template&id=15902728&scoped=true&"
import script from "./warnEvent.vue?vue&type=script&lang=js&"
export * from "./warnEvent.vue?vue&type=script&lang=js&"
import style0 from "./warnEvent.vue?vue&type=style&index=0&id=15902728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15902728",
  null
  
)

export default component.exports